import { render, staticRenderFns } from "./SettingsSidebar.vue?vue&type=template&id=333bd10e&scoped=true"
import script from "./SettingsSidebar.vue?vue&type=script&lang=js"
export * from "./SettingsSidebar.vue?vue&type=script&lang=js"
import style0 from "./SettingsSidebar.vue?vue&type=style&index=0&id=333bd10e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333bd10e",
  null
  
)

export default component.exports